import { 
    GET_ALL_USERS,
    LOADING_DATA,
    FILTER_USER,
    CLEAR_ERRORS,
    SET_ERRORS,
    CLEAR_PERMISTION,
 } from '../types';
import axios from 'axios';

// Get all users
export const getAllUsers = () => dispatch => {
    dispatch({type: LOADING_DATA});
    axios.get('/users')
        .then(res => {
            dispatch({
                type: GET_ALL_USERS,
                payload: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_USERS,
                payload: []
            })
        })
}

export const updateUserPartner = (userId, dataPartner) => dispatch => {
    axios.post(`/user/${userId}/partner`, dataPartner)
        .then(() => {
            dispatch(getAllUsers())
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        })
}

export const filterUser = (filter) => dispatch => {
    dispatch({
        type: FILTER_USER,
        filter
    })
}

export const clearErrors = () => dispatch => {
    dispatch({ type: CLEAR_ERRORS });
}

export const clearPermistions = () => dispatch => {
    dispatch({ type: CLEAR_PERMISTION });
}